import React, { useEffect } from "react";

import PageWrapper from "../../components/page-wrapper";

import patientFavicon from "../../images/patient-favicon.ico";

import StickyTab from "../../components/sticky-tab";

import BasicHero from "./basic-hero";
import PatientCta from "../../components/patient-cta";

const PatientPageWrapper = ({ references, children, showStickyTab = true }) => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.href = patientFavicon;
  }, []);

  return (
    <PageWrapper variant="patient" references={references}>
      <BasicHero />
      {children}
      {showStickyTab && <StickyTab />}
      <PatientCta />
    </PageWrapper>
  );
};

export default PatientPageWrapper;
